import { useState } from 'react';

import { Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { CissTextField } from 'components/fields/';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function DetalhamentoCreditosImportacaFilter() {
    const [filterTitulo, setFilterTitulo] = useState<FilterValuesProps>({
        property: 'dsArquivo',
        operator: 'like',
        value: '',
    });

    const [filterInterval, setFilterInterval] = useState<FilterValuesProps>({
        property: 'dhInclusao',
        operator: 'bt',
        startDate: null,
        endDate: null,
    });

    return (
        <Filter
            filters={[
                { value: filterTitulo, setter: setFilterTitulo },
                { value: filterInterval, setter: setFilterInterval },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Arquivo"
                    value={filterTitulo.value}
                    onChange={(e) => setFilterTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ width: '100%', flex: 2 }}>
                <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns} localeText={{ start: 'Data Início', end: 'Data Fim' }}>
                    <DateRangePicker
                        value={[filterInterval.startDate ?? null, filterInterval.endDate ?? null]}
                        onChange={([startDate, endDate]) => {
                            setFilterInterval((oldState: FilterValuesProps) => ({
                                ...oldState,
                                startDate,
                                endDate,
                            }));
                        }}
                        slots={{ field: MultiInputDateRangeField }}
                        slotProps={{
                            field: { dateSeparator: 'até' },
                            textField: { autoComplete: 'off' },
                        }}
                    />
                </LocalizationProvider>
            </Grid>
        </Filter>
    );
}
